
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46route_45path_933hB2JdKW9TMeta } from "/working_dir/site/pages/[...route-path].vue?macro=true";
import { default as staticD4KsNf8iHrMeta } from "/working_dir/site/pages/static.vue?macro=true";
export default [
  {
    name: "routepath___en",
    path: "/:routepath(.*)*",
    component: () => import("/working_dir/site/pages/[...route-path].vue")
  },
  {
    name: "static___en",
    path: "/static",
    component: () => import("/working_dir/site/pages/static.vue")
  }
]